import React from 'react';
import './articulo70.css';
//import { articulo70 } from '../../json/articulo70';
//import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

const Articulo70 = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //const { nombre } = useParams();
  //const articulo = articulo70.find((articulo) => articulo.nombre === nombre);

  return (
    <div className='container container_detalle_rubro'>
      <div className='row'>
        <div className='col-12'>
          <div className='rubro_titulo'>
            <h3 className='title'>Ley de Transparencia</h3>
            <hr className='hr-gob' />
          </div>
        </div>
      </div>
      <div className='row'>
        {
          //articulo.formatos.map((formato, index) => {
            //const urlXLSX = "/Transparencia/xlsx/2022/a69_" + formato.xlsx + "_STPSH.xlsx";
            //const urlHTML = "/Transparencia/htm/a69_" + formato.html + "_STPSH.htm";
            //return (
              <div className='col-md-4 col-12'>
                
                  <div className='detalle_rubro_nombre'>
                    <h5>Articulo 70</h5>
                  </div>
                  <div className='detalle_rubro_enlaces'>
                    <a href='./Transparencia/xlsx/2023/a70_f01_g_STPSH.xlsx' target="_blank">XLSX</a>
                    <a href='./Transparencia/htm/a70_f01_g_STPSH.htm' target="_blank">Ver Tabla</a>
                  </div>
                
              </div>
            //);
          //})
        }
      </div>
    </div>
  );



};

export default Articulo70;